/**
 * 一次「同步更新」点击的去重 id：同一点击下多个平台接口只扣 1 次。
 * 同时记住按钮 kind，供 module-sync-jobs 等统一入口在请求头上报。
 */

export const TEMU_MANUAL_SYNC_CLICK_HEADER = 'X-Temu-Manual-Sync-Click';
export const TEMU_MANUAL_SYNC_KIND_HEADER = 'X-Temu-Manual-Sync-Kind';

const TTL_MS = 120000;

let clickId = '';
let clickKind = '';
let expiresAt = 0;

export function beginTemuManualSyncClick(kind = '') {
  const cryptoApi = typeof window !== 'undefined' ? window.crypto : undefined;
  const raw = (typeof cryptoApi?.randomUUID === 'function')
    ? cryptoApi.randomUUID()
    : `c${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
  clickId = String(raw).replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 80);
  if (clickId.length < 8) {
    clickId = `c${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
  }
  clickKind = String(kind || '').trim();
  expiresAt = Date.now() + TTL_MS;
  return clickId;
}

export function currentTemuManualSyncClickId() {
  if (!clickId || Date.now() > expiresAt) return '';
  return clickId;
}

export function currentTemuManualSyncKind() {
  if (!clickId || Date.now() > expiresAt) return '';
  return clickKind;
}

export function parseTemuShopIdFromPath(path) {
  const m = String(path || '').match(/\/shops\/(\d+)\//);
  return m ? m[1] : '';
}
